var geflechtsoption = document.querySelector('[data-option="Geflecht"]');

var fabricvalue = localStorage.getItem("fabric");

setTimeout(function(){document.querySelector("[data-option-value=" + CSS.escape(fabricvalue) + "]").click(); }, 200);


var brindle = document.getElementById("geflecht-brindle-img");
var harvest = document.getElementById("geflecht-harvest-img");
var copper = document.getElementById("geflecht-copper-img");
var geflechtswitcher = document.getElementById("geflechtswitcher");
var url = window.location.href;

if(url.includes("ttcc-brindle") || url.includes("ttcc-harvest") || url.includes("ttcc-copper")) {
  geflechtswitcher.style.display="flex";
}

 if(url.includes("ttcc-brindle")){
  	  document.getElementById("geflecht-brindle").checked = true;
   	  brindle.classList.add("geflechtborder");
      harvest.classList.remove("geflechtborder");
      copper.classList.remove("geflechtborder");
      var harvesturl = url.replace(/brindle/g, "harvest");
      var copperurl = url.replace(/brindle/g, "copper");
  }else if(url.includes("ttcc-harvest")){
  	  document.getElementById("geflecht-harvest").checked = true;
   	  brindle.classList.remove("geflechtborder");
      harvest.classList.add("geflechtborder");
      copper.classList.remove("geflechtborder");
      var brindleurl = url.replace(/harvest/g, "brindle");
      var copperurl = url.replace(/harvest/g, "copper");
  }else if(url.includes("ttcc-copper")){
  	  document.getElementById("geflecht-copper").checked = true;
   	  brindle.classList.remove("geflechtborder");
      harvest.classList.remove("geflechtborder");
      copper.classList.add("geflechtborder");
      var brindleurl = url.replace(/copper/g, "brindle");
      var harvesturl = url.replace(/copper/g, "harvest");
  }

var fabricswrapper = document.querySelector('[data-option="Fabric"]');

function showbrindle() {
  var url = window.location.href;
  if(!url.includes("ttcc-brindle")){
  	var fabric = document.querySelectorAll(".rio-product-option-title")[0].innerText.substring('Fabric: '.length);
  	localStorage.setItem("fabric", fabric);
    window.location.href=brindleurl;
  }
};

function showharvest() {
  var url = window.location.href;
  if(!url.includes("ttcc-harvest")){
  	var fabric = document.querySelectorAll(".rio-product-option-title")[0].innerText.substring('Fabric: '.length);
  	localStorage.setItem("fabric", fabric);
    window.location.href=harvesturl;
  }
};

function showcopper() {
  var url = window.location.href;
  if(!url.includes("ttcc-copper")){
  	var fabric = document.querySelectorAll(".rio-product-option-title")[0].innerText.substring('Fabric: '.length);
  	localStorage.setItem("fabric", fabric);
    window.location.href=copperurl;
  }
};

